<template>
  <div class="signDetailTable">
    <el-table
      :data="data"
      style="width: 100%;margin-bottom:10px;"
      border
      header-cell-class-name="cellCustomer headerCellCustomer ft14"
      cell-class-name="cellCustomer ft12"
    >
      <template slot="empty">
          <img class="data-pic" src="../../../../../assets/images/H5/null.png" alt="" />
          <br/>
          暂无数据
      </template>
      <el-table-column label="合同名称">
        <template>{{detail.info.name}}</template>
      </el-table-column>
      <el-table-column label="事件类型">
        <template slot-scope="scope">{{getStatus(scope.row.signStatus)}}</template>
      </el-table-column>
      <el-table-column label="发起签约时间">
        <template>{{detail.info.signStartTime}}</template>
      </el-table-column>
      <el-table-column prop="signStatusTime" label="操作时间"></el-table-column>
      <el-table-column prop="remark" label="理由"></el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  props: ["detail", "data"],
  data() {
    return {};
  },
  mounted() {},
  methods: {
    getStatus(flag) {
      let statusArrFlag = ["发起签约", "未签署", "签署完成", "拒签", "撤回"];
      return statusArrFlag[flag];
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>
